import { useReadContract } from 'wagmi';

import { EVM_SUPERSTATE_FUND_ALLOWLIST } from '@/constants/addresses';

import type { EthereumAddress } from '@/utils/models';

/**
 * Hook to check if an address is allowed for a specific fund on the Superstate allowlist
 */
export const useSuperstateFundAllowlist = (address?: EthereumAddress, fundSymbol?: string) =>
  useReadContract({
    address: EVM_SUPERSTATE_FUND_ALLOWLIST,
    abi: [
      {
        inputs: [
          { internalType: 'address', name: 'addr', type: 'address' },
          { internalType: 'string', name: 'fundSymbol', type: 'string' },
        ],
        name: 'isAddressAllowedForFund',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
      },
    ],
    functionName: 'isAddressAllowedForFund',
    args: address && fundSymbol ? [address, fundSymbol] : undefined,
  });
